module.exports = __webpack_public_path__ + "img/Geoinformation_solutions.fd46ddfb.svg";